if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open');
					
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}

			});
		}

		let allLight = document.getElementsByClassName('lightbox');
		let allLightLength = allLight.length;
		for(let i =0; i < allLightLength; i++){
			allLight[i].addEventListener('click', function(e){
				let wrapThis = this.getElementsByClassName('copy-wrap')[0];
				let check = checkParent(wrapThis,e.target);
				if(check === false){
					//if(!e.target.classList.contains('js-lightboxbtn')){
						this.classList.remove('open')
					//} 
					
				}
				console.log(e.target.classList.contains('js-lightboxbtn'))
				
			})
		}

		
		

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}

				if(document.getElementsByClassName('lightbox-video').length > 0){
					let allVideos = document.getElementsByClassName('lightbox-video');
					for(let h = 0; h < allVideos.length; h++){
						allVideos[h].pause();
					}
				}

			});
		}
		

	}


    $('.sym-slides').slick({
        accessibility: false,
		responsive: [
			{
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true
                }
            }
        ]
    });

	$('.split-slides').slick({
        accessibility: true,
		fade:true,
		responsive: [
			{
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
					dots:true
                }
            }
        ]
    });

	
	if(document.getElementById('splitFilter')){
		let tagFilters = document.getElementById('splitFilter').getElementsByTagName('li');

		$('.split-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			for(let h = 0; h < tagFilters.length; h++){
				if(h == nextSlide){
					tagFilters[h].classList.add('active')
				} else {
					tagFilters[h].classList.remove('active');
				}
			}
		});


		for(let i =0; i < tagFilters.length; i++){
			tagFilters[i].addEventListener('click', function(){
				let currentIndex = this.getAttribute('data-target');
				$('.split-slides').slick('slickGoTo',currentIndex);
				for(let h = 0; h < tagFilters.length; h++){
					if(tagFilters[h] == this){
						this.classList.add('active')
					} else {
						tagFilters[h].classList.remove('active');
					}
				}
			})
		}
	}
	
	$('.gallery-images').slick({
		arrows: true,
        infinite: true,
        accessibility: true,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    centerMode: false,
                }
            },
			{
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });


	$('.second-gallery__list').slick({
		arrows: true,
        infinite: true,
        accessibility: true,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    centerMode: false,
                }
            },
			{
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
					dots: true,
					arrows: false,
                }
            }
        ]
    });

    
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}



})();

function checkParent(parent, child) {
	if (parent.contains(child))
		return true;
		return false;
} 